// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_theme1_footer__752KQ","footer_logo":"Footer_theme1_footer_logo__VQ_yT","link":"Footer_theme1_link__uS_b2","copyright":"Footer_theme1_copyright__I8Kfb"};